import React from 'react';

interface LabelProps {
  children: React.ReactNode;
  htmlFor?: string;
  hint?: string;
}

export const Label: React.FC<LabelProps> = ({ children, htmlFor, hint }) => {
  return (
    <label className="block text-sm font-medium text-heading mb-1" htmlFor={htmlFor}>
      {children}
      {hint && <span className="text-faint font-normal ml-1">({hint})</span>}
    </label>
  );
};
